import { getSubscriptionPlanId, SubscriptionPlanId } from './subscription-plan';

/** Subscription status and expiry override legacy membership flags. */
export function getActiveSubscriptionPlanId(session: any, now = Date.now()): SubscriptionPlanId {
  const user = session?.data ?? session;
  const plan = getSubscriptionPlanId(user) ?? 'basic';
  if (plan === 'basic') return plan;
  const subscription = user?.subsctions ?? user?.subscription ?? {};
  const status = String(subscription.subscriptionStatus ?? user?.subscriptionStatus ?? '').toLowerCase();
  const end = subscription.subscriptionEndDate ?? user?.subscriptionEndDate;
  if (status && status !== 'active') return 'basic';
  if (end && (!Number.isFinite(Date.parse(end)) || Date.parse(end) <= now)) return 'basic';
  if (!status && (user?.subscriptionPlan || subscription.subscriptionPlan || subscription.membershipType)) return 'basic';
  return plan;
}

export function hasPaidPropertyAccess(session: any): boolean {
  return getActiveSubscriptionPlanId(session) !== 'basic';
}

export function hasPaidCiAccess(session: any): boolean {
  return ['intelligence', 'advisory'].includes(getActiveSubscriptionPlanId(session));
}
